// extracted by mini-css-extract-plugin
module.exports = {"container":"AnnouncementItem_container__2eRlB","column":"AnnouncementItem_column__PAtlN","item":"AnnouncementItem_item__2HSHW","link":"AnnouncementItem_link__4B6jU"};